"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getManualInvoiceFileName = void 0;
var getManualInvoiceFileName = function (manualInvoice) {
    var _a;
    return [manualInvoice.prefix, manualInvoice.mt.id.slice(-8), (_a = manualInvoice.mtInvoiceReference) === null || _a === void 0 ? void 0 : _a.slice(0, 20)]
        .filter(Boolean)
        .join('-');
};
exports.getManualInvoiceFileName = getManualInvoiceFileName;
//# sourceMappingURL=manual-invoice.js.map